/**
 * Computes the final `src` for an image element.
 *
 * Rules:
 * - data URIs (e.g. the loading placeholder) must never be mutated;
 * - placeholder assets are used as-is;
 * - urls that already carry a timestamp (`&time`, `&custom_time`, `&_t`) are
 *   left untouched so the browser cache keeps working;
 * - anything else gets a single `custom_time` cache-buster.
 *
 * Call this exactly once per src assignment and reuse the result for
 * preloading, so the preloaded url and the rendered url are byte-identical.
 */
const PLACEHOLDER_MARKERS = ['noimage.png', 'no_photo.svg', 'no_pic.gif'];
/** Shared with ImageHelper.checkTime so the two lists can never drift. */
export const TIMESTAMP_MARKERS = ['&time', '&custom_time', '&_t'];

export function finalImageSrc(url: string): string {
    if (!url || url.startsWith('data:')) {
        return url;
    }
    if (PLACEHOLDER_MARKERS.some(marker => url.includes(marker))) {
        return url;
    }
    if (TIMESTAMP_MARKERS.some(marker => url.includes(marker))) {
        return url;
    }
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}custom_time=${new Date().getTime()}`;
}
